import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ViewControls from './ViewControls';
import actions from '../duck/actions';
import { areEqual } from '../../../utils/array';
import { Loader, Typography } from 'kangarootime-ui';
import PhotoViewControl from './PhotoViewControl';
import GridView from './GridView/GridView';
import TableView from './TableView/TableView';
import LightboxPhoto from './LightboxPhoto';
import RaisedContainer from '../../../components/RaisedContainer';

class PhotosWaitingForApproval extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      selectedPhotos: [],
      selectedPhotoIds: [],
      filteredClassroom: 'all',
      showLightbox: false,
      lightboxPhoto: null,
      activeView: 'grid'
    };
  }

  get allPhotoIds () {
    const { photos } = this.props;

    if (photos) {
      return photos.map(photo => photo.id);
    }

    return [];
  }

  get allPhotosForApproval () {
    const { photos } = this.props;

    if (photos) {
      return photos.map(photo => ({
        photoId: photo.group_image_id,
        childId: photo.child_id
      }));
    }

    return [];
  }

  get pendingPhotosToShow () {
    const { photos } = this.props;
    const { filteredClassroom } = this.state;

    if (filteredClassroom === 'all') {
      return photos;
    }

    return photos.filter(photo => photo.room_id === filteredClassroom);
  }

  handlePhotoSelection = photo => {
    const { id, group_image_id: photoId, child_id: childId } = photo;
    const { selectedPhotos, selectedPhotoIds } = this.state;
    let selectedPhotosCopy = [...selectedPhotos];
    let selectedPhotoIdsCopy = [...selectedPhotoIds];

    if (selectedPhotoIdsCopy.includes(id)) {
      const indexToRemove = selectedPhotoIdsCopy.indexOf(id);

      selectedPhotosCopy.splice(indexToRemove, 1);
      selectedPhotoIdsCopy.splice(indexToRemove, 1);
    } else {
      selectedPhotosCopy.push({ photoId, childId });
      selectedPhotoIdsCopy.push(id);
    }

    this.setState({ selectedPhotos: selectedPhotosCopy, selectedPhotoIds: selectedPhotoIdsCopy });
  }

  selectAll = () => {
    const { selectedPhotoIds } = this.state;

    areEqual(selectedPhotoIds, this.allPhotoIds) ? this.setState({ selectedPhotos: [], selectedPhotoIds: [] }) : this.setState({ selectedPhotos: this.allPhotosForApproval, selectedPhotoIds: this.allPhotoIds });
  }

  // photoIds is an array of objects. Each object has a `photoId` and `childId` property
  approvePhotos = photoIds => {
    if (photoIds.length === 0) {
      return;
    }

    this.props.approvePhoto(photoIds);
  }

  // photoIds is an array of objects. Each object has a `photoId` and `childId` property
  rejectPhotos = photoIds => {
    if (photoIds.length === 0) {
      return;
    }

    this.props.rejectPhoto(photoIds);
  }

  viewPhotoInLightbox = (lightboxPhoto = null) => {
    const showLightbox = lightboxPhoto !== null;

    this.setState({
      showLightbox,
      lightboxPhoto
    });
  }

  setView = viewType => this.setState({ activeView: viewType });

  render () {
    const { rooms, performingAction } = this.props;
    const { showLightbox, filteredClassroom, selectedPhotoIds, selectedPhotos, activeView, lightboxPhoto } = this.state;

    return (
      <RaisedContainer style={{ marginTop: 12 }}>
        <div style={{ margin: 16 }}>
          <div className='flex-rows' style={{ alignItems: 'center' }}>
            <Typography type='header'>Photo Approval Required</Typography>
            <PhotoViewControl
              changeView={this.setView}
              activeView={activeView}
            />
          </div>
          <div>
            <ViewControls
              rooms={rooms}
              selectedRoom={filteredClassroom}
              toggleSelectAll={this.selectAll}
              filterPendingPhotosByRoomId={id => this.setState({ filteredClassroom: id })}
              approvePhotos={() => this.approvePhotos(selectedPhotos)}
              rejectPhotos={() => this.rejectPhotos(selectedPhotos)}
              buttonsDisabled={selectedPhotos.length === 0 || performingAction}
            />
          </div>
          <Loader loading={performingAction} />
          { activeView === 'grid'
            ? <GridView
              pendingPhotos={this.pendingPhotosToShow}
              selectedPhotoIds={selectedPhotoIds}
              handlePhotoSelection={this.handlePhotoSelection}
              approvePhotos={this.approvePhotos}
              rejectPhotos={this.rejectPhotos}
              viewPhotoInLightbox={this.viewPhotoInLightbox}
            />
            : <TableView
              pendingPhotos={this.pendingPhotosToShow}
              selectedPhotoIds={selectedPhotoIds}
              handlePhotoSelection={this.handlePhotoSelection}
              approvePhotos={this.approvePhotos}
              rejectPhotos={this.rejectPhotos}
              viewPhotoInLightbox={this.viewPhotoInLightbox}
            />
          }
          { lightboxPhoto !== null
            ? <LightboxPhoto
              isOpen={showLightbox}
              onClose={() => this.viewPhotoInLightbox(null)}
              photoDetails={lightboxPhoto}
              approvePhoto={this.approvePhotos}
              rejectPhoto={this.rejectPhotos}
            /> : null
          }
        </div>
      </RaisedContainer>
    );
  }
}

function mapStateToProps (state) {
  return {
    rooms: state.rooms.rooms.filter(room => room.name !== 'Floats'),
    performingAction: state.gallery.overview.pending.performingAction
  };
}

function mapDispatchToProps (dispatch) {
  return {
    approvePhoto: photoId => dispatch(actions.approvePhotosRequest(photoId)),
    rejectPhoto: photoId => dispatch(actions.rejectPhotosRequest(photoId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotosWaitingForApproval);
